import * as Dialog from '@radix-ui/react-dialog';
import { useMemo, useState } from 'react';
import { GLOSSARY } from '@/content/glossary';

/** Searchable glossary dialog (§10.8, Appendix D). */
export function Glossary() {
  const [query, setQuery] = useState('');
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return GLOSSARY;
    return GLOSSARY.filter((e) => e.term.toLowerCase().includes(q) || e.definition.toLowerCase().includes(q));
  }, [query]);

  return (
    <Dialog.Root>
      <Dialog.Trigger className="rounded-md border border-slate-300 px-2 py-1 text-sm hover:bg-slate-100 dark:border-slate-600 dark:hover:bg-slate-800">
        Glossary
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-black/40" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 flex max-h-[80vh] w-[min(90vw,640px)] -translate-x-1/2 -translate-y-1/2 flex-col rounded-lg border border-slate-200 bg-white p-4 shadow-xl dark:border-slate-700 dark:bg-slate-800">
          <Dialog.Title className="text-base font-semibold">Glossary</Dialog.Title>
          <Dialog.Description className="sr-only">Plain-language definitions of PAL terms.</Dialog.Description>
          <input
            autoFocus
            placeholder="Search terms…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="mt-2 w-full rounded border border-slate-300 px-2 py-1 text-sm dark:border-slate-600 dark:bg-slate-900"
          />
          <dl className="mt-3 overflow-y-auto pr-1">
            {filtered.map((e) => (
              <div key={e.term} className="mb-2">
                <dt className="text-sm font-semibold text-slate-800 dark:text-slate-100">{e.term}</dt>
                <dd className="text-xs text-slate-600 dark:text-slate-300">{e.definition}</dd>
              </div>
            ))}
            {filtered.length === 0 && <p className="text-sm text-slate-500">No matching terms.</p>}
          </dl>
          <Dialog.Close className="mt-2 self-end rounded border border-slate-300 px-3 py-1 text-sm hover:bg-slate-100 dark:border-slate-600 dark:hover:bg-slate-800">
            Close
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
